import Dialog from "src/components/Dialog";
import { useTranslation } from "react-i18next";

export default function GenericFailureDialog({ onDismiss, isOpen, ...rest }) {
  const { t } = useTranslation();
  return (
    <Dialog
      {...rest}
      buttons={[{ onClick: onDismiss, text: t("buttons.ok") }]}
      heading={t("messages.actionFailed")}
      text={t("messages.tryLater")}
      isOpen={isOpen}
    />
  );
}
